__webpack_require__.p = "https://developer.microsoft.com/games/partner/";